import React from 'react';
import { appendClassProps } from '../util';
import { TextType } from './index.types';
/**
 - Use text for any text on the screen to conform to typography styles
 */
export const Text = ({ type = TextType.body, inline = false, overrideColor = false, overflow = 'ellipsis', wrap, center, children, className, textClassName, 'data-testid': dataTestId }) => {
    const textClasses = `${overflow === 'ellipsis' ? 'overflow-hidden overflow-ellipsis' : ''}${center ? ' w-full text-center' : ''} ${wrap ? 'whitespace-pre-line' : 'whitespace-nowrap'}${appendClassProps(textClassName)}`;
    let component;
    switch (type) {
        case TextType.h1:
            component = (React.createElement("h1", { "data-testid": dataTestId, className: `text-3xl md:text-4xl lg:text-5xl font-bold ${textClasses}` }, children));
            break;
        case TextType.h2:
            component = (React.createElement("h2", { "data-testid": dataTestId, className: `text-2xl md:text-3xl lg:text-4xl ${textClasses}` }, children));
            break;
        case TextType.h3:
            component = (React.createElement("h3", { "data-testid": dataTestId, className: `text-xl md:text-2xl lg:text-3xl ${textClasses}` }, children));
            break;
        case TextType.h4:
            component = (React.createElement("h4", { "data-testid": dataTestId, className: `text-lg md:text-xl lg:text-2xl ${textClasses}` }, children));
            break;
        case TextType.h5:
            component = (React.createElement("h5", { "data-testid": dataTestId, className: `text-md md:text-lg lg:text-xl ${textClasses}` }, children));
            break;
        case TextType.h6:
            component = (React.createElement("h6", { "data-testid": dataTestId, className: `text-sm md:text-base lg:text-lg ${textClasses}` }, children));
            break;
        case TextType.custom:
            component = (React.createElement("span", { "data-testid": dataTestId, className: textClasses }, children));
            break;
        case TextType.body:
        default:
            component = (React.createElement("span", { "data-testid": dataTestId, className: `text-base ${textClasses}` }, children));
            break;
    }
    return (React.createElement("div", { className: `${overrideColor ? '' : 'text-blue-800 dark:text-blue-200'} ${inline ? 'inline' : 'flex'}${appendClassProps(className)}` }, component));
};
export * from './index.types';
//# sourceMappingURL=index.js.map